import { render, staticRenderFns } from "./OrderFabricReadyMadeTypeTable.vue?vue&type=template&id=2709465a&scoped=true&"
import script from "./OrderFabricReadyMadeTypeTable.vue?vue&type=script&lang=js&"
export * from "./OrderFabricReadyMadeTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2709465a",
  null
  
)

export default component.exports